import { ThemeToggle as SharedThemeToggle } from '../../shared/theme/ThemeToggle.js'
import { useAdminTheme } from '../hooks/useAdminTheme.js'

/**
 * Dark / light toggle for the admin header. Thin wrapper: wires the shared
 * presentational `ThemeToggle` to `useAdminTheme` and the `.admin-theme-toggle`
 * style scope.
 */
export function ThemeToggle() {
  const { theme, toggle } = useAdminTheme()
  return (
    <SharedThemeToggle
      theme={theme}
      toggle={toggle}
      className="admin-theme-toggle"
    />
  )
}
